// import external dependencies
import 'jquery';
import LazyLoad from 'vanilla-lazyload';
import AOS from 'aos';
import 'aos/dist/aos.css';

window.APTIM = {};
window.initLazyLoad = new LazyLoad({ elements_selector: '.lazy' });
AOS.init({ once: true });
jQuery(function () {
  window.initLazyLoadOnLoaded = new LazyLoad({
    elements_selector: '.lazy-onloaded',
  });

  let forms = [...document.querySelectorAll('.universal-form-container')];
  forms.map((form) =>
    disableSubmitOnNullCheckboxes(form, [
      ...form.querySelectorAll('.flysheet_pdfs .wpcf7-list-item > input'),
    ])
  );
});

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';
import contactPage from './routes/contact';
import searchResults from './routes/search';
import postTypeArchiveGlossary from './routes/glossary';
import postTypeArchiveProject from './routes/archives/project';
import postTypeArchivePerson from './routes/archives/person';
import postTypeArchivePublication from './routes/archives/publication';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  searchResults,
  blog,
  contactPage,
  postTypeArchiveGlossary,
  singleGlossary: postTypeArchiveGlossary,
  postTypeArchiveProject,
  postTypeArchivePerson,
  postTypeArchivePublication,
});

// Load Events
$(() => routes.loadEvents());

const disableSubmitOnNullCheckboxes = (form, _arr) => {
  //dont allow the form to be sent if there are no checkboxes selected
  _arr.map((check) => {
    check.addEventListener('click', (e) => {
      let checkedCount = form.querySelectorAll(
        '.flysheet_pdfs .wpcf7-list-item > input:checked'
      );
      if (checkedCount.length == 0) {
        e.preventDefault();
        alert('At least one pdf file needs to be selected');
      }
    });
  });
};
